// extracted by mini-css-extract-plugin
export default {"container":"OrganisationsRoute_container__PVRxY","mainContainer":"OrganisationsRoute_mainContainer__H8fxI"};